import { useProject } from '@/features/projects/overview/use-project.query';

import { TopbarWrapper } from '../topbar';

import { ProjectHeaderActions } from './shared/project-header-actions';
import {
  isProjectHeaderVisibleState,
  projectIdState,
} from '@/features/projects/project.state';
import { MinimizedHeader } from '@/ui/typography/across-platform';
import { styled } from 'goober';
import { NavButtonDefault } from '@/features/navbar/navbar.styles';
import { Inline } from '@/ui/line/line';
import { useNavigateTo } from '@/routes/hooks/use-navigate-to';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/ui/icons/icon';
import { SmallText } from '@/ui/typography/widgets';
import { colors } from '@/theme/colors';
import { useAtomValue } from 'jotai';

export const ProjectOverviewHeader = () => {
  const { t } = useTranslation('default');
  const projectId = useAtomValue(projectIdState);
  const { data: project } = useProject(projectId);
  const navigateTo = useNavigateTo();
  const isProjectHeaderVisible = useAtomValue(isProjectHeaderVisibleState);

  if (!project) return null;

  return (
    <TopbarWrapper
      name="project-overview"
      justify="space-between"
      bgColor="transparent"
    >
      <LeftContentWrapper alignItems="center">
        <BackButton onClick={() => navigateTo.projects()}>
          <Icon icon="ArrowLeftBack" />
          <SmallText color={colors.blue.primaryA}>{t`Back`}</SmallText>
        </BackButton>
        {!isProjectHeaderVisible && (
          <MinimizedHeader>{project.name}</MinimizedHeader>
        )}
      </LeftContentWrapper>
      <ProjectHeaderActions />
    </TopbarWrapper>
  );
};

const LeftContentWrapper = styled(Inline)`
  ${({ theme }) => theme.animations.fadeAnimation()};
`;

const BackButton = styled('div')`
  ${({ theme }) => NavButtonDefault(theme)}

  background-color: transparent;
  color: ${({ theme }) => theme.colors.blue.primaryB};
  border: none;
  padding: 0;
  display: flex;
  gap: 4px;
  padding: 8px;
  flex-grow: 0;
  box-sizing: border-box;

  &:hover {
    ${({ theme }) =>
      `
      background-color: ${theme.colors.blue.c9};
    `};
  }
`;
